import React from 'react';
import DevicesTabState from './devicesTabState/DevicesTabState';
import DevicesControlPanel from './components/DevicesControlPanel/DevicesControlPanel';
import DevicesList from './components/DevicesList/DevicesList';
import DevicesPagination from './components/DevicesPagination/DevicesPagination';
import style from './DevicesTab.module.scss';

const DevicesTab: React.FC = () => {
	return (
		<DevicesTabState>
			<div className={style.container}>
				<DevicesControlPanel />
				<DevicesList />
				<DevicesPagination />
			</div>
		</DevicesTabState>
	);
};

export default DevicesTab;
